import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="w-full bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="relative overflow-hidden rounded-lg bg-primary-50 border border-primary-200 p-7 md:p-12">
          <div className="absolute -right-16 -top-16 w-56 h-56 rounded-full bg-primary-100/70"></div>
          <div className="absolute -right-6 -bottom-20 w-40 h-40 rounded-full bg-accent-100/60"></div>

          <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-6">
              <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50 border border-primary-200 text-primary-700 text-xs font-medium">
                <i className="ri-mail-send-line"></i>
                吃瓜日报 · 每日一封
              </span>
              <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
                每天一分钟，把今日最火的瓜收进邮箱
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                精选三条当日热帖 + 一句高赞神回复，早上八点送到。不灌水、不追踪、随时可退。
              </p>
            </div>
            <div className="lg:col-span-6">
              <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
                <SubscribeForm variant="inline" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}